module.exports = __webpack_public_path__ + "img/west-vvip-gal-14.206eb77e.jpg";